document.addEventListener('DOMContentLoaded', function() {
    const footerBlocks = document.querySelectorAll('.footer-block.grid__item');

    function enableFooterAccordions() {
      if (window.innerWidth <= 749) {
        footerBlocks.forEach(block => {
          const heading = block.querySelector('.footer-block__heading');
          const content = block.querySelector('.footer-block__details-content, .footer-block__brand-info, .footer-block__contact, .footer-block__newsletter');

          if (!heading || !content) return;

          if (heading.classList.contains('accordion-initialized')) return;
          heading.classList.add('accordion-initialized');

          content.style.maxHeight = '0';
          content.style.overflow = 'hidden';
          content.style.transition = 'max-height 0.3s ease';

          heading.addEventListener('click', function() {
            const isOpen = heading.classList.toggle('is-open');
            if (isOpen) {
              content.style.maxHeight = content.scrollHeight + 'px';
            } else {
              content.style.maxHeight = '0';
            }
          });
        });
      } else {
        footerBlocks.forEach(block => {
          const heading = block.querySelector('.footer-block__heading');
          const content = block.querySelector('.footer-block__details-content, .footer-block__brand-info, .footer-block__contact, .footer-block__newsletter');
          if (heading && content) {
            heading.classList.remove('is-open', 'accordion-initialized');
            content.style.maxHeight = '';
            content.style.overflow = '';
            content.style.transition = '';
          }
        });
      }
    }

    enableFooterAccordions();

    window.addEventListener('resize', () => {
      enableFooterAccordions();
    });
});
